import React from 'react';
import ProductModal from 'components/ProductModal';
import { Flex, Lowercase, MarginBox, Text } from 'UI';

interface TitleBlockProps {
  compact?: boolean;
  availableInUserCountry: boolean;
  extraLarge: boolean;
  partNumber: string;
  profile?: string;
  designation?: string;
  brandLabel?: string;
}

export const TitleBlock = ({
  compact,
  availableInUserCountry,
  extraLarge,
  partNumber,
  profile,
  designation,
  brandLabel,
}: TitleBlockProps) => {
  let textType: 'text_dim_bold' | 'h2' | 'h2_black_45';
  if (!availableInUserCountry) {
    textType = 'h2_black_45';
  } else if (compact) {
    textType = 'text_dim_bold';
  } else {
    textType = 'h2';
  }
  const subType = availableInUserCountry ? 'lead' : 'lead_dim';

  const profileText = profile?.trim() || partNumber;
  const designationText = designation?.trim();
  const brandText = brandLabel?.trim();
  let subtitle = '';
  if (designationText && brandText) {
    subtitle = `${designationText} - ${brandText}`;
  } else if (designationText) {
    subtitle = designationText;
  } else if (brandText) {
    subtitle = brandText;
  }

  return (
    <MarginBox mr={10}>
      <Flex direction="column" minWidth={extraLarge ? 315 : 0} wrap="wrap">
        <ProductModal
          key="tire-ref-num"
          id="tire-ref-num"
          triggerComponent={
            <Text type={textType} cursor="pointer" disableGutter hoverUnderLine>
              {profileText}
            </Text>
          }
          referenceNumber={partNumber}
        />

        {subtitle ? (
          <Text type={subType} transform="capitalize">
            <Lowercase>{subtitle}</Lowercase>
          </Text>
        ) : null}
      </Flex>
    </MarginBox>
  );
};
